<template>
  <DetailsSkeleton v-if="!paintingDetails" />
  <div v-else>
    <div class="
        grid grid-cols-2
        layout-padding
        mt-[100px]
        h-full
        work-details-container
        py-[40px]
      ">
      <div class="
          col-span-2
          lg:col-span-1
          h-max
          mt-5
          lg:mt-0 lg:min-h-[500px]
          flex flex-col
          justify-center
          text-section
          lg:order-first
          order-last
        ">
        <div class="flex items-center mb-4 cursor-pointer" @click="$router.go(-1)">
          <i class="fa fa-arrow-left rtl:rotate-180"></i>
          <div class="ltr:ml-2 rtl:mr-2">{{ content.back }}</div>
        </div>  
        <div>
          <div class="text-lg font-bold">
            {{ content.artWorks }} / {{ content[paintingDetails?.data?.type] }}
          </div>
          <div class="lg:text-4xl text-2xl mt-4 font-bold">
            {{ paintingDetails?.data?.title }}
          </div>

          <div class="mt-12">
            {{ paintingDetails?.data?.collection?.title }} ,
            {{ paintingDetails?.data?.collection?.year.substring(0, 4) }}
          </div>
          <div class="mt-4 w-10/12 text-justify" v-html="paintingDetails?.data?.description">

          </div>
        </div>
      </div>

      <img :src="paintingDetails?.data?.image" alt="slide" class="
          col-span-2
          lg:col-span-1 lg:order-last
          order-first
          lg:h-[550px]
          h-[300px]
          w-full
          object-contain
        " />
    </div>

    <div class="layout-padding mb-24" v-if="paintingDetails?.data?.collection?.id">
      <div class="flex justify-between items-center my-8">
        <div class="lg:text-3xl text-2xl ltr:mr-2 rtl:ml-2">
          {{ content.moreFromThisCollection }}
        </div>
        <div class="
            lg:h-20
            h-12
            flex
            justify-between
            items-center
            text-3xl
            bg-primary
            w-max
            transition-all
            duration-700
            cursor-pointer
            lg:min-w-[216px]
            min-w-[120px]
          ">
          <div class="lg:px-8 px-4 lg:py-6 py-2 prev-painting-details group">
            <img src="/static/images/icons/arrow-left.svg" alt="arrow-left " class="
                lg:w-8
                w-auto
                h-6
                md:ltr:ml-2 md:rtl:mr-2
                rtl:rotate-180
                md:group-hover:ml-0
                transition-all
                duration-300
              " />
          </div>
          <div class="lg:px-8 px-4 lg:py-6 py-2 next-painting-details group">
            <img src="/static/images/icons/arrow-right.svg" class="
                lg:w-8
                w-auto
                h-6
                md:ltr:mr-2 md:rtl:ml-2
                rtl:rotate-180
                md:group-hover:mr-0
                transition-all
                duration-300
              " alt="arrow-left " />
          </div>
        </div>
      </div>
      <div class="mt-16">
        <swiper :breakpoints="breakpoints" :navigation="navigation">
          <swiper-slide v-for="work in paintingDetails?.other" :key="work.id">
            <PaintingCard :work="work" :collectionTitle="work?.collection?.title"
              :collectionYear="work?.collection?.year" />
          </swiper-slide>
          <swiper-slide>
            <router-link :to="`/collectiondetails/${paintingDetails?.data?.collection?.id}`">
              <div class="h-[475px] relative grid place-content-center">
                <div class="
                    h-[475px]
                    more-card border
                    absolute
                    left-0
                    top-0
                    w-full border-[#e5e7eb]
                    
                  "></div>
                <div class="text-2xl uppercase">{{ content.more }}</div>
              </div>
            </router-link>
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
import PaintingCard from "/src/components/UI/Cards/PaintingCard.vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import SwiperCore from "swiper";
import { Navigation } from "swiper";
import "swiper/swiper-bundle.css";
import "swiper/components/effect-fade/effect-fade.min.css";
import "swiper/swiper.min.css";
import "swiper/components/navigation/navigation.min.css";
SwiperCore.use([Navigation]);
export default {
  inject: ["content"],
  props: ["id"],
  data() {
    return {
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 40,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 60,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 80,
        },
      },
      navigation: {
        nextEl: ".next-painting-details",
        prevEl: ".prev-painting-details",
      },
    };
  },
  computed: {
    paintingDetails() {
      return this.$store.getters["works/work"];
    },
  },
  components: {
    PaintingCard,
    Swiper,
    SwiperSlide,
  },
  watch: {
    id() {
      this.$store.dispatch("works/getWork", this.id);
      this.$store.dispatch("works/resetWorkDetails");
    },
  },
  mounted() {
    setTimeout(() => {
      this.$store.dispatch("works/getWork", this.id);
    }, 2);
  },
  unmounted() {
    this.$store.dispatch("works/resetWorkDetails");
  },
};
</script>